// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"484":"1b560c32","773":"428027cc","892":"14d3461a"}[chunkId] + ".chunk.css";
};